import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Identificar el borde",
    opening: localizedGenderNode(
      [
      "Hoy noto cuando el pensamiento corre al borde.",
      "Pauso conmigo.",
      "Una respiracion."
    ],
      [
      "Hoy noto cuando el pensamiento corre al borde.",
      "Pauso conmigo.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que pensamiento salta directo al borde?",
      "Que es lo peor que imagino?",
      "Que siento en mi cuerpo cuando sube?"
    ],
      [
      "Que pensamiento salta directo al borde?",
      "Que es lo peor que imagino?",
      "Que siento en mi cuerpo cuando sube?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un pensamiento extremo es un pensamiento, no realidad."
    ],
      [
      "Un pensamiento extremo es un pensamiento, no realidad."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El primer disparador",
    opening: localizedGenderNode(
      [
      "Hoy identifico que activa la catastrofe.",
      "Pauso.",
      "Una respiracion."
    ],
      [
      "Hoy identifico que activa la catastrofe.",
      "Pauso.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cuando sube más rapido?",
      "Que disparador se repite una y otra vez?",
      "Que intento proteger?"
    ],
      [
      "Cuando sube más rapido?",
      "Que disparador se repite una y otra vez?",
      "Que intento proteger?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A veces la mente intensifica para sentirse en control."
    ],
      [
      "A veces la mente intensifica para sentirse en control."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Hecho versus historia",
    opening: localizedGenderNode(
      [
      "Hoy separo hecho de imaginacion.",
      "Pauso.",
      "Una respiracion."
    ],
      [
      "Hoy separo hecho de imaginacion.",
      "Pauso.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cual es el hecho unico que tengo ahora?",
      "Que historia se le pone encima?",
      "Que todavia no se?"
    ],
      [
      "Cual es el hecho unico que tengo ahora?",
      "Que historia se le pone encima?",
      "Que todavia no se?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "La incertidumbre se siente peligrosa, pero no es necesariamente peligro."
    ],
      [
      "La incertidumbre se siente peligrosa, pero no es necesariamente peligro."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Bajar la velocidad de la pelicula",
    opening: localizedGenderNode(
      [
      "Hoy bajo la velocidad de la pelicula.",
      "Pauso.",
      "Una respiracion."
    ],
      [
      "Hoy bajo la velocidad de la pelicula.",
      "Pauso.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "En que punto la pelicula se vuelve extrema?",
      "Que imagen se repite?",
      "Que necesito en este momento?"
    ],
      [
      "En que punto la pelicula se vuelve extrema?",
      "Que imagen se repite?",
      "Que necesito en este momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cuando bajo la velocidad, tengo espacio para respirar."
    ],
      [
      "Cuando bajo la velocidad, tengo espacio para respirar."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Patron repetido",
    opening: localizedGenderNode(
      [
      "Hoy identifico un patron constante.",
      "Pauso.",
      "Una respiracion."
    ],
      [
      "Hoy identifico un patron constante.",
      "Pauso.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que tema se repite más?",
      "A que hora del día sube?",
      "Que hago justo despues?"
    ],
      [
      "Que tema se repite más?",
      "A que hora del día sube?",
      "Que hago justo despues?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un patron conocido me ayuda a ver que se repite, no que es nuevo."
    ],
      [
      "Un patron conocido me ayuda a ver que se repite, no que es nuevo."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "La señal del cuerpo",
    opening: localizedGenderNode(
      [
      "Hoy noto la primera señal del cuerpo.",
      "Pauso.",
      "Una respiracion."
    ],
      [
      "Hoy noto la primera señal del cuerpo.",
      "Pauso.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Donde en el cuerpo empieza?",
      "Que cambia en la respiracion?",
      "Que quiero hacer cuando llega?"
    ],
      [
      "Donde en el cuerpo empieza?",
      "Que cambia en la respiracion?",
      "Que quiero hacer cuando llega?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "El cuerpo senala antes que el pensamiento."
    ],
      [
      "El cuerpo senala antes que el pensamiento."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Un limite interno",
    opening: localizedGenderNode(
      [
      "Hoy creo un limite interno para el pensamiento.",
      "Pauso.",
      "Una respiracion."
    ],
      [
      "Hoy creo un limite interno para el pensamiento.",
      "Pauso.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cuando el pensamiento ya cruza un limite?",
      "Que frase interna lo intensifica?",
      "Que quiero decirme en su lugar?"
    ],
      [
      "Cuando el pensamiento ya cruza un limite?",
      "Que frase interna lo intensifica?",
      "Que quiero decirme en su lugar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un limite interno no borra un pensamiento, lo suaviza."
    ],
      [
      "Un limite interno no borra un pensamiento, lo suaviza."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Una revision suave",
    opening: localizedGenderNode(
      [
      "Hoy elijo una revision suave.",
      "Pauso.",
      "Una respiracion."
    ],
      [
      "Hoy elijo una revision suave.",
      "Pauso.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que se con certeza ahora?",
      "Que estoy asumiendo sin revisar?",
      "Que puedo dejar a un lado por ahora?"
    ],
      [
      "Que se con certeza ahora?",
      "Que estoy asumiendo sin revisar?",
      "Que puedo dejar a un lado por ahora?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una pequeña precision baja una gran dramatizacion."
    ],
      [
      "Una pequeña precision baja una gran dramatizacion."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Una relacion suave con el pensamiento",
    opening: localizedGenderNode(
      [
      "Hoy me encuentro con mi mente sin lucha.",
      "Pauso.",
      "Una respiracion."
    ],
      [
      "Hoy me encuentro con mi mente sin lucha.",
      "Pauso.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que intenta hacer mi mente por mi?",
      "Que teme que ocurra?",
      "Como se siente cuando soy suave con ella?"
    ],
      [
      "Que intenta hacer mi mente por mi?",
      "Que teme que ocurra?",
      "Como se siente cuando soy suave con ella?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Incluso un pensamiento extremo es un intento de proteger."
    ],
      [
      "Incluso un pensamiento extremo es un intento de proteger."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Una necesidad bajo el miedo",
    opening: localizedGenderNode(
      [
      "Hoy nombro una necesidad bajo el miedo.",
      "Pauso.",
      "Una respiracion."
    ],
      [
      "Hoy nombro una necesidad bajo el miedo.",
      "Pauso.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que necesidad hay bajo el pensamiento?",
      "Que me calmaria un poco?",
      "Que me pido a mi?"
    ],
      [
      "Que necesidad hay bajo el pensamiento?",
      "Que me calmaria un poco?",
      "Que me pido a mi?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cuando identifico una necesidad, tengo direccion."
    ],
      [
      "Cuando identifico una necesidad, tengo direccion."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Una pequeña peticion a mi",
    opening: localizedGenderNode(
      [
      "Hoy me hago una pequeña peticion.",
      "Pauso.",
      "Una respiracion."
    ],
      [
      "Hoy me hago una pequeña peticion.",
      "Pauso.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que pequeña peticion es posible para mi?",
      "Cual seria una pequeña señal de que funciona?",
      "Que puede estorbarme?"
    ],
      [
      "Que pequeña peticion es posible para mi?",
      "Cual seria una pequeña señal de que funciona?",
      "Que puede estorbarme?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una pequeña peticion no es una solucion, es un comienzo."
    ],
      [
      "Una pequeña peticion no es una solucion, es un comienzo."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Un cambio del 5%",
    opening: localizedGenderNode(
      [
      "Hoy elijo un cambio pequeño en mi habito de pensar.",
      "Pauso.",
      "Una respiracion."
    ],
      [
      "Hoy elijo un cambio pequeño en mi habito de pensar.",
      "Pauso.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que habito puedo cambiar en un cinco por ciento?",
      "Cuando me conviene más intentarlo?",
      "Cual seria un primer paso?"
    ],
      [
      "Que habito puedo cambiar en un cinco por ciento?",
      "Cuando me conviene más intentarlo?",
      "Cual seria un primer paso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un cambio pequeño crea un camino nuevo."
    ],
      [
      "Un cambio pequeño crea un camino nuevo."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un ancla pequeña",
    opening: localizedGenderNode(
      [
      "Hoy construyo un ancla pequeña para un día dificil.",
      "Pauso.",
      "Una respiracion."
    ],
      [
      "Hoy construyo un ancla pequeña para un día dificil.",
      "Pauso.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que frase me sostiene?",
      "Que lugar en mi cuerpo se siente seguro?",
      "Que me ayuda a volver a este momento?"
    ],
      [
      "Que frase me sostiene?",
      "Que lugar en mi cuerpo se siente seguro?",
      "Que me ayuda a volver a este momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un ancla pequeña me recuerda que no tengo que correr con el pensamiento."
    ],
      [
      "Un ancla pequeña me recuerda que no tengo que correr con el pensamiento."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Una frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy cierro con suavidad.",
      "Pauso.",
      "Una respiracion."
    ],
      [
      "Hoy cierro con suavidad.",
      "Pauso.",
      "Una respiracion."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Que aprendi sobre mis pensamientos catastroficos?",
      "Cual es la señal más temprana?",
      "Que frase me devuelve al momento de antes?"
    ],
      [
      "Que aprendi sobre mis pensamientos catastroficos?",
      "Cual es la señal más temprana?",
      "Que frase me devuelve al momento de antes?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo estar con un pensamiento y elegir una respuesta."
    ],
      [
      "Puedo estar con un pensamiento y elegir una respuesta."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת.",
      "נשימה אחת."
    ),
  },
].map(buildNormalizedDay);

export const catastrophicThoughtsBlueprintEs = buildNormalizedPilotBlueprint({
  id: "catastrophic_thoughts_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "catastrophic_thoughts",
  category: "general",
  journeyName: {
    he: "מחשבות קטסטרופליות",
    en: "Catastrophic Thoughts",
    es: "Pensamientos catastroficos",
  },
  days,
});

export default catastrophicThoughtsBlueprintEs;
